<div ng-if="$ctrl.hasHeader" class="property-value-filter-header">
    <span>{{$ctrl.config.propertyLabel}}</span>
    <span>{{$ctrl.config.optionsLabel}}</span>
    <span>{{$ctrl.config.valueLabel}}</span>
</div>
<c-property-value-filter ng-repeat="fltr in $ctrl.filters track by $index" filter="fltr" config="$ctrl.config"></c-property-value-filter>
